module.exports = __webpack_public_path__ + "static/media/giftoria-logo.213d5eba.svg";